import React from "react";
import {useTranslation} from "react-i18next";

function Groups() {
    const {t} = useTranslation();

    return (
        <div>
            <h2>{t("menu.groups")}</h2>
        </div>
    );
}

export default Groups;